import React from 'react';
import { NavDropdown } from "react-bootstrap";

const LocaleDropdown = ({ locale, setLocale }) => {
  if (locale === "en") {
    return (
      <NavDropdown
        title={
          <span>
            <img
              alt="English"
              src="https://www.e-slides.net/wp-content/plugins/wpglobus/flags/us.png"
            />
            &nbsp;EN
          </span>
        }
        id="basic-nav-dropdown"
      >
        <NavDropdown.Item onClick={() => setLocale("fr")}>
          <img
            alt="French"
            src="https://www.e-slides.net/wp-content/plugins/wpglobus/flags/fr.png"
          />
          &nbsp;FR
        </NavDropdown.Item>
      </NavDropdown>
    );
  }
  return (
    <NavDropdown
      title={
        <span>
          <img
            alt="French"
            src="https://www.e-slides.net/wp-content/plugins/wpglobus/flags/fr.png"
          />
          &nbsp;FR
        </span>
      }
      id="basic-nav-dropdown"
    >
      <NavDropdown.Item onClick={() => setLocale("en")}>
        <img
          alt="English"
          src="https://www.e-slides.net/wp-content/plugins/wpglobus/flags/us.png"
        />
        &nbsp;EN
      </NavDropdown.Item>
    </NavDropdown>
  );
};

export default LocaleDropdown;